(function initBirthdayPopup() {
  
  // ==========================================
  // ⚙️ RÉGLAGE : ACTIVER OU DÉSACTIVER LE POP-UP
  // Mettez true pour l'activer, ou false pour le cacher.
  // ==========================================
  const POPUP_ACTIF = false; 

  // Si le pop-up est désactivé, on arrête tout le script ici
  if (!POPUP_ACTIF) {
    console.log("Pop-up Birthstone désactivé.");
    return; 
  }

  const currentPath = window.location.pathname.toLowerCase();
  
  if (currentPath.includes('/collections/birthstones-1')) {
    
    setTimeout(function() {
      if(localStorage.getItem('birthday_popup_filled')) return;

      // 1. INJECTION DES CSS 
      if (!document.getElementById("birthstone-css")) {
        const style = document.createElement('style');
        style.id = "birthstone-css";
        style.innerHTML = `
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600&display=swap');
          @import url('https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css');
          
          .popup-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(3px); display: none; justify-content: center; align-items: center; z-index: 99999; opacity: 0; transition: opacity 0.5s ease; }
          .popup-overlay.show { opacity: 1; }
          
          .popup-content { background: #ffffff; padding: 40px; border-radius: 12px; width: 90%; max-width: 420px; overflow: visible !important; text-align: center; font-family: 'Montserrat', sans-serif; box-shadow: 0 15px 35px rgba(0,0,0,0.15); position: relative; transform: translateY(30px); transition: transform 0.5s ease; }
          
          .popup-overlay.show .popup-content { transform: translateY(0); }
          .close-btn { position: absolute; top: 12px; right: 18px; font-size: 28px; font-weight: 300; cursor: pointer; color: #999; transition: color 0.3s; z-index: 10; }
          .close-btn:hover { color: #000000; }
          .popup-content h2 { color: #000000; font-weight: 600; font-size: 22px; margin-bottom: 12px; text-transform: uppercase; }
          .popup-content p { color: #000000; font-weight: 400; font-size: 14px; margin-bottom: 25px; line-height: 1.6; }
          .popup-content input { width: 100%; padding: 14px; margin-bottom: 15px; border: 1px solid #e0e0e0; border-radius: 6px; font-family: 'Montserrat', sans-serif; font-size: 14px; box-sizing: border-box; outline: none; transition: border 0.3s; color: #000000; }
          
          .popup-content input::placeholder { color: #a0a0a0; opacity: 1; text-transform: none; font-weight: 300; }
          
          .popup-content input:focus { border-color: #DAA5AD; }
          .popup-content button { width: 100%; padding: 14px; background: #DAA5AD; color: #ffffff; border: none; border-radius: 6px; font-family: 'Montserrat', sans-serif; font-weight: 600; font-size: 15px; letter-spacing: 0.5px; cursor: pointer; transition: background 0.3s, transform 0.1s; text-transform: uppercase; margin-top: 5px; }
          .popup-content button:hover { background: #c58f97; }
          .popup-content button:active { transform: scale(0.98); }
          .countdown-box { margin-top: 25px; padding: 20px; background: #fdf9fa; border-radius: 8px; border: 1px solid #f2e1e3; }
          .days-number { display: block; font-size: 52px; font-weight: 600; color: #DAA5AD; line-height: 1; margin-bottom: 5px; }
          .days-label { font-size: 12px; color: #000000; text-transform: uppercase; letter-spacing: 1.5px; font-weight: 400; }
          .highlight { color: #DAA5AD; font-weight: 600; }
          
          .flatpickr-calendar { font-family: 'Montserrat', sans-serif; box-shadow: 0 10px 25px rgba(0,0,0,0.15) !important; border: none; border-radius: 8px; z-index: 999999 !important; }
        `;
        document.head.appendChild(style);
      }

      // 2. INJECTION DU HTML (Le formulaire est désormais protégé contre les rechargements)
      if (!document.getElementById("birthstone-popup-overlay")) {
        const div = document.createElement('div');
        div.id = "birthstone-popup-overlay";
        div.className = "popup-overlay";
        div.innerHTML = `
          <div class="popup-content" id="birthstone-popup-content">
            <span class="close-btn" id="close-popup">&times;</span>
            <div id="popup-step-1">
              <h2>A Special Birthday Treat</h2>
              <p>Enter your email and birth date to receive an exclusive <span class="highlight">€10 gift card</span> as an <span class="highlight">early gift</span> ahead of your special day.</p>
              
              <!-- onsubmit="return false;" bloque le comportement natif du navigateur -->
              <form id="birthday-form" onsubmit="return false;">
                <input type="email" id="user-email" placeholder="Your email address" required />
                <input type="text" id="user-birthdate" placeholder="DD/MM/YYYY" required />
                <button type="submit" id="submit-btn">Unlock My Gift</button>
              </form>
            </div>
            
            <div id="popup-step-2" style="display: none;">
              <h2>Almost time to celebrate!</h2>
              <p>Check your inbox soon. Your €10 coupon will be sent to your email.</p>
              <div class="countdown-box">
                <span id="days-left" class="days-number">0</span>
                <span class="days-label">Days until your birthday</span>
              </div>
            </div>
          </div>
        `;
        document.body.appendChild(div);
      }

      // 3. CHARGEMENT DE FLATPICKR ET INITIALISATION
      if (!document.getElementById("flatpickr-js")) {
        const fpJs = document.createElement('script');
        fpJs.id = "flatpickr-js";
        fpJs.src = "https://cdn.jsdelivr.net/npm/flatpickr";
        fpJs.onload = function() {
           flatpickr("#user-birthdate", {
               allowInput: true,       
               dateFormat: "Y-m-d",    
               altInput: true,         
               altFormat: "d/m/Y",     
               disableMobile: true,
               onReady: function(selectedDates, dateStr, instance) {
                 if (instance.altInput) {
                     instance.altInput.placeholder = "DD/MM/YYYY";
                 }
               }
           });
        };
        document.head.appendChild(fpJs);
      }

      // 4. AFFICHAGE, ANIMATION ET VERROUILLAGE DU SCROLL
      const overlay = document.getElementById("birthstone-popup-overlay");
      overlay.style.display = 'flex';
      
      document.body.style.overflow = 'hidden'; 
      
      setTimeout(() => { overlay.classList.add("show"); }, 10);

      // 5. FERMETURE DU POP-UP
      document.getElementById("close-popup").addEventListener("click", function() {
        overlay.classList.remove("show");
        document.body.style.overflow = ''; 
        setTimeout(() => { overlay.style.display = 'none'; }, 500);
      });

      overlay.addEventListener("click", function(e) {
        if(e.target === overlay) {
          document.getElementById("close-popup").click();
        }
      });

      // 6. SOUMISSION DU FORMULAIRE ET COMPTEUR 
      document.getElementById("birthday-form").addEventListener("submit", function(e) {
        e.preventDefault(); 
        e.stopImmediatePropagation(); // Empêche les autres scripts du thème de détecter l'envoi
        
        const birthdateValue = document.getElementById("user-birthdate").value;
        const emailValue = document.getElementById("user-email").value;
        
        if(!birthdateValue || !emailValue) return;

        const btn = document.getElementById("submit-btn");
        btn.innerText = "PROCESSING...";
        btn.disabled = true;

        // Construction manuelle des données pour contourner l'action de formulaire Shopify par défaut
        const formData = new FormData();
        formData.append('form_type', 'customer');
        formData.append('utf8', '✓');
        formData.append('contact[tags]', 'newsletter, birthday_gift');
        formData.append('contact[note][Birthday]', birthdateValue);
        formData.append('contact[email]', emailValue);
        
        fetch('/contact', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          localStorage.setItem('birthday_popup_filled', 'true');

          const bdate = new Date(birthdateValue);
          const today = new Date();
          let nextBday = new Date(today.getFullYear(), bdate.getMonth(), bdate.getDate());
          
          if (today.getTime() > nextBday.getTime()) {
            nextBday.setFullYear(today.getFullYear() + 1);
          }
          
          const diffTime = Math.abs(nextBday - today);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
          
          // Affiche le compteur sans jamais recharger la page
          document.getElementById("popup-step-1").style.display = 'none';
          document.getElementById("popup-step-2").style.display = 'block';
          document.getElementById("days-left").innerText = diffDays;
        })
        .catch(error => {
          console.error('Erreur lors de la soumission :', error);
          btn.innerText = "TRY AGAIN";
          btn.disabled = false;
        });
      });

    }, 5000); 
  }
})();